define('ordersProofsheetButtonView',[
  'app',
  'module',
  'underscore',
  'ordersOrderUtils',
  'buttonView'
], function (
  App,
  Module,
  _,
  OrderUtils,
  ButtonView
) {
  'use strict';

  Module.exports = ButtonView.extend({
    className: 'orders-proofsheet-button-view ' + ButtonView.prototype.className,

    attributes: function () {
      return {
        'title': _.i18n('common.proofsheet'),
        'type': 'doc',
        'color': 'green'
      };
    },

    initialize: function() {
      this.options.text = _.i18n('common.proofsheet');
      this.options.type = 'doc';    
      this.customer = this.options.customer;
    },

    onClick: function(e) {
      e.stopPropagation();
      e.preventDefault();
      var url = null;

      if(this.options.customer) {
        url = OrderUtils.getProofSheetUrl(this.model, this.customer);
        if (url)         
          window.open(url, '_blank');           
      } else {
        this.customer = App.request('customers:entity:end-user-id', this.model.get('endUserId'));
        this.customer.fetch().done(_.bind(function () {      
          url = OrderUtils.getProofSheetUrl(this.model, this.customer);
          if (url)         
            window.open(url, '_blank');   
        }, this));
      }      
    }
  });
});
  
